export default {
  footerUnavailable: 'Parcours de conseil bientôt disponible',
  footerDisabled: 'Mise à jour de votre profil nécessaire',
  tileHeaderError: 'INDICATEUR NON FIABLE',
  tileHeaderWarning: 'INDICATEUR PEU FIABLE',
  tileHeaderSuccess: 'INDICATEUR FIABLE',
}
